module.exports = __webpack_public_path__ + "img/bell.e0c114df.png";